module.exports = __webpack_public_path__ + "media/packs/public/images/mail/pretty/brand@3x-0638e57a631fc5048b98bf42df1aee54.png";